import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col } from 'react-bootstrap';


function ReportGestao({ dados }) {
    const [activeData, setActiveData] = useState();
    const [activeIndex, setActiveIndex] = useState();

    const types =
    {
        "Possui Débitos de Tributos Federais?": "Governança",
        "Possui Parcelamentos de Tributos Federais?": "Governança",
        "Possui Inscrição no CEIS?": "Governança",
        "Possui Inscrição no CNEP?": "Governança",
        "Possui Débitos de FGTS?": "Social",
        "Possui Débitos de Contribuição Previdenciária (INSS)?": "Social",
        "Possui Acidentes de Trabalho?": "Social",
        "Possui Investigações do MPT?": "Social",
        "Está na Lista Suja do Trabalho Escravo?": "Social",
        "Possui Autos de Infração emitidos pelo IBAMA?": "Ambiental",
        "Possui Autos de Infração emitidos pela SEMAD/MG?": "Ambiental"
    }

    useEffect(() => {

        // dados['Riscos de Prestadores de Serviços de Destinação de Resíduos (Listados no RAPP CTF/IBAMA)'] = [
        //     {
        //         "CNPJ": "05.470.466/0001-74",
        //         "Razão Social": "VALLOUREC TUBES",
        //         "Possui Débitos de Tributos Federais?": "Não",
        //         "Possui Parcelamentos de Tributos Federais?": "Não",
        //         "Possui Inscrição no CEIS?": "Não",
        //         "Possui Inscrição no CNEP?": "Sim",
        //         "Possui Débitos de FGTS?": "Não",
        //         "Possui Débitos de Contribuição Previdenciária (INSS)?": "Não",
        //         "Possui Acidentes de Trabalho?": "Não",
        //         "Possui Investigações do MPT?": "Não",
        //         "Está na Lista Suja do Trabalho Escravo?": "Não",
        //         "Possui Autos de Infração emitidos pelo IBAMA?": "Não",
        //         "Possui Autos de Infração emitidos pela SEMAD/MG?": "Sim"
        //     },
        //     {
        //         "CNPJ": "05.470.466/0001-74",
        //         "Razão Social": "VALLOUREC TUBES 2",
        //         "Possui Débitos de Tributos Federais?": "Sim",
        //         "Possui Parcelamentos de Tributos Federais?": "Não",
        //         "Possui Inscrição no CEIS?": "Não",
        //         "Possui Inscrição no CNEP?": "Sim",
        //         "Possui Débitos de FGTS?": "Não",
        //         "Possui Débitos de Contribuição Previdenciária (INSS)?": "Não",
        //         "Possui Acidentes de Trabalho?": "Não",
        //         "Possui Investigações do MPT?": "Não",
        //         "Está na Lista Suja do Trabalho Escravo?": "Não",
        //         "Possui Autos de Infração emitidos pelo IBAMA?": "Não",
        //         "Possui Autos de Infração emitidos pela SEMAD/MG?": "Não"
        //     }
        // ]

    })

    const handleClickInfo = (index) => {
        setActiveIndex(null);
        setActiveData(null);
        setTimeout(() => {
            setActiveIndex(index);
            setActiveData(dados['Riscos de Prestadores de Serviços de Destinação de Resíduos (Listados no RAPP CTF/IBAMA)'][index]);
        }, 500);
        
    }
    
    return (
        <>
            {dados && dados['Riscos de Prestadores de Serviços de Destinação de Resíduos (Listados no RAPP CTF/IBAMA)'] && dados['Riscos de Prestadores de Serviços de Destinação de Resíduos (Listados no RAPP CTF/IBAMA)'].length > 0 ?
                <>
                    <div className='mb-5'>
                        <h6 style={{ width: 'fit-content' }}>Riscos de Prestadores de Serviços de Destinação de Resíduos | RAPP CTF/IBAMA</h6>
                    </div>
                    <div style={{ width: '100%', clear: 'both' }}></div>

                    <Row  className='scrollbar' style={{ height: 'calc(100vh - 560px)' }}>
                        <Col className='scrollbar' style={{ height: 'calc(100vh - 560px)' }}>
                            {dados['Riscos de Prestadores de Serviços de Destinação de Resíduos (Listados no RAPP CTF/IBAMA)'].map((item, index) =>
                                <div key={index} className={'list-residuos d-flex justify-content-between user-selected-none cursor-pointer ' + (activeIndex === index ? 'active' : '')} onClick={(e) => handleClickInfo(index)}>
                                    <span>{index + 1 + '.'} {item['Razão Social']} ({item.CNPJ})</span> <i className='bi bi-chevron-right'></i>
                                </div>
                            )}
                        </Col>
                        <Col className='scrollbar' style={{ height: 'calc(100vh - 560px)', 'overflowX': 'hidden' }}>
                            <table className="table" style={{ marginTop: '-9px', marginLeft: '15px' }}>
                                <tbody>
                                    {activeData && Object.keys(activeData).length > 0 && Object.keys(activeData).map((key, i) => (
                                        key.toString().indexOf('?') > -1 && (
                                            <tr key={i}>
                                                <td>{(activeIndex + 1) + '.' + (i - 1) + '.'} {key}</td>
                                                <td><div className={'rect-tag small ' + types[key].replace('ç', 'c').toLowerCase()}>{types[key]}</div></td>
                                                <td><b className={activeData[key] === 'Sim' ? 'text-red-700' : ''}>{activeData[key]}</b></td>
                                            </tr>
                                        )
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </>
            : <Row><span className="fs-6">Não foram identificado "Riscos de Prestadores de Serviços de Destinação de Resíduos (Listados no RAPP CTF/IBAMA)"</span></Row>}
        </>
    )
}

export default ReportGestao;